import { Box, Stack } from "@mui/material";
import useLocationQueryDateRange from "../../../v2/hooks/useLocationQueryDateRange";
import React, { useState } from "react";
import useGetAllBillings from "./Utilities/hooks/useGetAllBillings";
import BillingsTable from "./Utilities/BillingsTable";
import useLocationQueryParams from "../../../v2/hooks/useLocationQueryParams";
import BasicFilterSelect from "../../../v2/common/BasicFilterSelect";
import ProductTotalTable from "./Utilities/ProductTotalTable";
import {VIEW_TYPES} from "./Utilities/billingUtils";
import DateRangeForm from "../../../v2/common/DateRangeForm";
import {Link as RouterLink} from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export default function AllBillings() {
  const { params, setParams } = useLocationQueryParams();
  const { startDate, endDate, setDates } = useLocationQueryDateRange();
  const [viewFilter, setViewFilter] = useState(params.pageFilter || "amountCharged");
  const payload = { startDate, endDate }
  const { columns, totalCount, rows, loading } = useGetAllBillings(payload, viewFilter);

  const handleTableCellClick = (params) => {
    window.location.replace(params);
  };

  const handleViewTypeChange = (option) => {
    const nextValue = option?.id;
    setViewFilter(nextValue);
    setParams({ ...params, pageFilter: nextValue });
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
          <RouterLink to={'/billing-summary'} className="tms-no-underline">
            <Box sx={styles.backLink}>
              <Box>
                <ArrowBackIosNewIcon sx={styles.arrowBack}/>
              </Box>
              <Box mt={'1px'}>Back to billing summary</Box>
            </Box>
          </RouterLink>
        </Box>
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={styles.formContainer}
          spacing={2}
        >
          <Box component={"h1"} sx={styles.heading}>
            Billings
          </Box>
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Box sx={styles.viewSelectContainer}>
              <BasicFilterSelect
                placeholder={"Select view"}
                options={VIEW_TYPES}
                value={VIEW_TYPES.find((option) => option.id === viewFilter)}
                onChange={handleViewTypeChange}
                listBoxHeight={380}
                isClearable={false}
                textFieldStyle={styles.textFieldStyle}
              />
            </Box>
            <DateRangeForm
                startDate={startDate}
                endDate={endDate}
                setDates={setDates}
            />
          </Box>
        </Stack>

        <Box>
          <BillingsTable
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            loading={loading}
            handleTableCellClick={handleTableCellClick}
          />
        </Box>

        <Box mt={5}>
          <Box component={"h1"} sx={styles.heading}>
            Product SKU
          </Box>
          <ProductTotalTable viewMetric={viewFilter} />
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    fontFamily: "LarsseitRegular",
    letterSpacing: "-0.02em",
    color: "#0C2728",
    backgroundColor: "#EFEAE7",
    pt: "109px",
    pb: 10,
    minHeight: "100vh",
  },
  container: {
    px: { xs: 2, sm: 6 },
    maxWidth: "1440px",
    position: "relative",
  },
  formContainer: {
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    mb: { xs: "24px", sm: "40px" },
    mt: { xs: "18px", sm: "24px" }
  },
  heading: {
    m: 0,
    fontFamily: "LarsseitMedium",
    fontSize: 24,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    color: "#0C2728",
    mb: 2
  },
  viewSelectContainer: {
    width: "250px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
  },
  textFieldStyle:  {
    [`& fieldset`]: {
      borderRadius: '8px',
    },
    '& .MuiInputBase-input': {
      height: '12px',
    },
  },
  backLink:{
    color: '#302E2A',
    position: 'relative',
    fontFamily: 'FustatBold',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'flex-end',
    gap: '20px',
  },
  arrowBack: {
    color: '#003300',
    marginRight:'8px',
    borderRadius: '0px',
    fontSize: '14px',
    position: 'absolute',
    left: '0',
    top: '3px'
  },
};
